import coach from '@/api/coach';

import { FETCH_COACH, FETCH_AVAILABLE_DATES, FETCH_AVAILABLE_TIMES } from './types';

export default {
    [FETCH_COACH]({ commit }) {
        return coach
            .get()
            .then(resp => commit(FETCH_COACH, resp));
    },
    [FETCH_AVAILABLE_DATES]({ state, commit }) {
        return coach
            .getAvailableDates(state.last_date)
            .then(resp => commit(FETCH_AVAILABLE_DATES, resp));
    },
    [FETCH_AVAILABLE_TIMES]({ commit }, payload) {
        return coach
            .getAvailableTimes(payload.date)
            .then(resp => commit(FETCH_AVAILABLE_TIMES, resp.available_times));
    },
};



// WEBPACK FOOTER //
// ./src/store/coach/actions.js